import { sortByDateCreated } from '../util/date/dateUtils';
import React from 'react';
import { Loader } from '../util/Loader';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const status = (snapshotStatus, changeSetReviewType, t) => {
  const statusInfo = {
    consultant_review: {
      approved: {
        text: t('accepted_all_outstanding_changes_and_closed_the_manager_review'),
        icon: 'done'
      },
      rejected: {
        text: t('rejected_changes_and_closed_the_manager_review'),
        icon: 'close'
      },
      finalized: {
        text: t('completed_their_manager_review'),
        icon: 'zoom_in'
      },
      started: {
        text: t('started_manager_qa_review'),
        icon: 'engineering'
      }
    },
    client_review: {
      approved: {
        text: t('accepted_all_outstanding_changes_and_closed_the_client_review'),
        icon: 'done'
      },
      rejected: {
        text: t('rejected_changes_and_closed_the_client_review'),
        icon: 'close'
      },
      finalized: {
        text: t('client_review_completed'),
        icon: 'zoom_in'
      },
      started: {
        text: t('started_client_qa_review'),
        icon: 'engineering'
      }
    }
  };
  return {
    icon: statusInfo[changeSetReviewType][snapshotStatus].icon,
    text: statusInfo[changeSetReviewType][snapshotStatus].text
  };
};
const downloadLinkOrPendingStatus = (snapshot, t) => {
  if (snapshot.rnd_report.pdf_generation_status !== 'success') {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/React.createElement("style", null, `
          .change-set-snapshot-status-loader .loader-spinner {
            height: 20px;
            width: 20px;
          }
        `), /*#__PURE__*/React.createElement("div", {
      className: "mr-2"
    }, t('please_wait_while_pdf_is_being_generated')), /*#__PURE__*/React.createElement("div", {
      style: {
        width: '5px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "change-set-snapshot-status-loader"
    }, /*#__PURE__*/React.createElement(Loader, null)));
  } else {
    return /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("a", {
      href: snapshot.link_to_file,
      target: "_blank",
      rel: "noreferrer",
      download: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "fa fa-download"
    }), " Download"));
  }
};
export class ChangeSet {
  constructor(_ref) {
    let {
      changeSet = {},
      t,
      onViewChecklist = null
    } = _ref;
    this.changeSet = changeSet;
    this.t = t;
    this.onViewChecklist = onViewChecklist;
  }
  getSnapshots() {
    return this.changeSet?.report_snapshots?.sort(sortByDateCreated) || [];
  }
  getSnapshotActorName(snapshot) {
    return snapshot.actor?.name || this.changeSet.author?.name || 'Unknown';
  }
  getLatestSnapshot() {
    return this.getSnapshots()[0];
  }
  getSnapshotStatus(snapshot) {
    return status(snapshot.status, this.changeSet.review_type, this.t);
  }
  getSnapshotDownloadLinkOrPendingStatus(snapshot) {
    return downloadLinkOrPendingStatus(snapshot, this.t);
  }
  isCostOnly() {
    return this.changeSet.internal_review_type === 'cost_only' || this.changeSet.internal_review_type === 1;
  }
  hasChecklistAnswers() {
    return this.changeSet.checklist_answers && this.changeSet.checklist_answers.length > 0;
  }
  getChecklistLink() {
    if (this.hasChecklistAnswers() && this.onViewChecklist) {
      return /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        variant: "link",
        onClick: () => this.onViewChecklist(this.changeSet.checklist_answers)
      }, /*#__PURE__*/React.createElement("span", {
        className: "fa fa-list"
      }), " ", this.t('view_checklist'));
    }
    return /*#__PURE__*/React.createElement("span", null, "-");
  }
  getInternalReviewTypeText() {
    const types = {
      'rnd_only': this.t('rnd_report_only'),
      'cost_only': this.t('cost_only'),
      'both': this.t('both_rnd_report_and_cost'),
      0: this.t('rnd_report_only'),
      1: this.t('cost_only'),
      2: this.t('both_rnd_report_and_cost')
    };
    return types[this.changeSet.internal_review_type] || this.t('rnd_report_only');
  }
  isUnderClientReview() {
    return this.changeSet?.review_type === 'client_review';
  }
}